import { useEffect, useState } from "react";
import { globalGetService, globalPutService } from "../../../../utils/globalApiServices";
import { getCapeTownConventionApi, putCapeTownConventionApi } from "../apiServices";
import { useParams } from "react-router-dom";
import { checkApiStatus } from "../../../../utils";
import { Button, Grid, Tooltip, Typography } from "@mui/material";
import { PermissionWrapper } from "../../../../wrappers";
import { trackActivity } from "../../../../utils/mixpanel";
import { Edit } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import { PageLoader, CustomEditor } from "../../../../shared_elements";

const CapeTownConvention = () => {
    const [isLoading, setLoading] = useState(false);
    const { leaseSlug } = useParams();
    const [capeTownData, setCapeTownData] = useState();
    const [isEditConvention, setEditConvention] = useState(false);
    const [prevData, setPrevData] = useState({});
    useEffect(() => {
        getCapeTownConvention();
    }, [])

    const getCapeTownConvention = () => {
        setLoading(true);
        globalGetService(getCapeTownConventionApi(leaseSlug)).then(response => {
            if (checkApiStatus(response)) {
                setCapeTownData(response?.data?.data);
            }
            setLoading(false)

        })
    }
    const onEditCapeTownConvention = () => {
        setLoading(true);
        globalPutService(putCapeTownConventionApi(leaseSlug), capeTownData).then(response => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
                trackActivity('Item Edited', { page_title: `Edit Headlines Cape Town Convention`, success_msg: response?.data?.message, item_slug: leaseSlug, payload: capeTownData, response: response?.data })
                setEditConvention(false);
            }
            else {
                enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
                trackActivity('Item Edited', { page_title: `Edit Headlines Cape Town Convention`, error_msg: response?.data?.message, item_slug: leaseSlug, payload: capeTownData, response: response?.data })
            }
            setLoading(false);
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Headlines`, page_type: page_type, })
    }
    return (
        <section className="cap-town-conteiner">
            <Grid sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }} margin='10px 0 15px'>
                <Grid>
                    <Typography color="primary" fontSize='18px'>Cape Town Convention</Typography>
                </Grid>
                <Grid>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "cape_town_convention", operationType: ['U'] }}>
                        {!isEditConvention && <Tooltip title="Edit" arrow> <Edit fontSize="small" color="primary" sx={{ cursor: 'pointer' }} onClick={() => { setEditConvention(true); setPrevData(capeTownData); handleItemClicked('Cape Town Convention EditIcon') }} /> </Tooltip>}
                    </PermissionWrapper>
                    {isEditConvention && <Button size='small' color='primary' variant='outlined' sx={{ cursor: 'pointer' }} onClick={() => { setEditConvention(false); setCapeTownData(prevData); handleItemClicked("Cape Town Convention Cancel Button"); }}>Cancel</Button>}
                    {isEditConvention && <Button size='small' color='primary' variant='contained' sx={{ cursor: 'pointer', marginInline: '5px' }} onClick={() => { onEditCapeTownConvention(); handleItemClicked("Cape Town Convention Save Button"); }} >Save</Button>}
                </Grid>
            </Grid>
            <CustomEditor
                value={capeTownData?.cape_town_convention}
                disabled={!isEditConvention}
                onChange={(data) => setCapeTownData(prev => ({ ...prev, cape_town_convention: data }))}
            />
            {isLoading ? <PageLoader /> : null}
        </section >
    )
}
export default CapeTownConvention;